import { css } from '@emotion/react';

import useGroupProduct from '../../../../../hooks/useGroupProduct';

import { DealProduct, GroupKey, GroupMember } from '../../../../../types';

import OptionItemList from './OptionItemList';
import ListItem from '../../ListItem';
import DealProductStepper from '../../../../../shared/DealProductStepper';

const stepper = css`
  .title {
    line-height: 30px;
  }
`;

interface Props {
  productNo: number;
  groupKeys: GroupKey[];
  groupMembers: GroupMember[];
  dealProduct: DealProduct;
}

export default function OptionContent({
  productNo,
  groupKeys,
  groupMembers,
  dealProduct,
}: Props) {
  const { optionList, changeOptionItem } = useGroupProduct({ productNo, groupKeys, groupMembers });

  return (
    <>
      {optionList.map((option) => (
        <OptionItemList
          key={option.title}
          title={option.title}
          descriptionType={option.descriptionType}
          options={option.options}
          selectedOption={option.selectedOption}
          changeOptionItem={changeOptionItem}
        />
      ))}
      <ListItem
        title="구매수량"
        css={stepper}
      >
        <DealProductStepper dealProduct={dealProduct} />
      </ListItem>
    </>
  );
}
